module.exports = __webpack_public_path__ + "static/media/20170129_120907.a787b966.jpg";